var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose, Transform, Type } from 'class-transformer';
import { AlertOutputType, AlertCorrelationOperator, SeverityLevel, UnifiedAlertSource } from '@logz-pkg/enums';
import { AlertScheduleModel } from '../alert-schedule';
import { MetricQueryModel, MetricTrigger, SubComponentModel } from '../sub-component';
export class AlertOutputRecipients {
    emails = [];
    notificationEndpoints = [];
}
__decorate([
    Expose({ name: 'notificationEndpointIds' }),
    Transform((notificationEndpoints) => notificationEndpoints.map(notificationEndpoint => notificationEndpoint.id), { toPlainOnly: true }),
    Transform(value => (Array.isArray(value) ? value.map(endpoint => endpoint.id || endpoint) : []), {
        toClassOnly: true,
    }),
    __metadata("design:type", Array)
], AlertOutputRecipients.prototype, "notificationEndpoints", void 0);
export class AlertOutput {
    suppressNotificationsMinutes = 60;
    type = AlertOutputType.Json;
    recipients = new AlertOutputRecipients();
}
__decorate([
    Type(() => AlertOutputRecipients),
    __metadata("design:type", AlertOutputRecipients)
], AlertOutput.prototype, "recipients", void 0);
export class BaseAlertModel {
    id;
    uid;
    title = '';
    createdBy = null;
    createdAt = null;
    updatedBy = null;
    updatedAt = null;
    description = '';
    searchTimeFrameMinutes = 15;
    sendToAll = false;
    rca = false;
    rcaNotificationEndpointIds = [];
    // Form-only companion to rcaNotificationEndpointIds — holds the full endpoint
    // objects the UI needs for the unified RecipientsField control. Not persisted
    // directly; the UI hydrates it from rcaNotificationEndpointIds on load and
    // the save flow writes the IDs back. Serializes away via toPlain.
    rcaNotificationEndpoints = [];
    rcaNotificationEmails = [];
    useAlertNotificationEndpointsForRca = true;
    linkedFolder;
    linkedDashboard;
    linkedPanel;
    runbook;
    dailyInvocationLimit;
    softDailyInvocationLimit;
    dashboardId;
    panelId;
    folderId;
    tags = [];
    output = new AlertOutput();
    isEnabled = true;
    isProtected = false;
}
__decorate([
    Transform(() => undefined, { toPlainOnly: true }),
    __metadata("design:type", Array)
], BaseAlertModel.prototype, "rcaNotificationEndpoints", void 0);
__decorate([
    Transform(value => value?.join(','), { groups: ['csv'] }),
    __metadata("design:type", Array)
], BaseAlertModel.prototype, "tags", void 0);
__decorate([
    Transform(JSON.stringify, { groups: ['csv'] }),
    Type(() => AlertOutput),
    __metadata("design:type", AlertOutput)
], BaseAlertModel.prototype, "output", void 0);
__decorate([
    Expose({ name: 'enabled' }),
    __metadata("design:type", Boolean)
], BaseAlertModel.prototype, "isEnabled", void 0);
class SubComponentCorrelations {
    correlationOperators = [AlertCorrelationOperator.And];
    joins = [];
}
export class AlertModel extends BaseAlertModel {
    source = UnifiedAlertSource.Logs;
    correlations = new SubComponentCorrelations();
    subComponents = [new SubComponentModel()];
    schedule = new AlertScheduleModel();
    mitreTags;
}
__decorate([
    Transform(JSON.stringify, { groups: ['csv'] }),
    __metadata("design:type", SubComponentCorrelations)
], AlertModel.prototype, "correlations", void 0);
__decorate([
    Transform(JSON.stringify, { groups: ['csv'] }),
    Type(() => SubComponentModel),
    __metadata("design:type", Array)
], AlertModel.prototype, "subComponents", void 0);
__decorate([
    Transform(JSON.stringify, { groups: ['csv'] }),
    __metadata("design:type", AlertScheduleModel)
], AlertModel.prototype, "schedule", void 0);
export class MetricAlertModel extends BaseAlertModel {
    source = UnifiedAlertSource.Metrics;
    severityLevel = SeverityLevel.Medium;
    trigger = new MetricTrigger();
    conditionRefId = 'A';
    queries = [new MetricQueryModel()];
}
__decorate([
    Type(() => MetricTrigger),
    __metadata("design:type", MetricTrigger)
], MetricAlertModel.prototype, "trigger", void 0);
__decorate([
    Type(() => MetricQueryModel),
    __metadata("design:type", Array)
], MetricAlertModel.prototype, "queries", void 0);
export function isLogAlert(alert) {
    return alert.source === UnifiedAlertSource.Logs || !alert.source;
}
export function isMetricAlert(alert) {
    return alert.source === UnifiedAlertSource.Metrics;
}
export const AlertExportFields = [
    'id',
    'title',
    'createdBy',
    'createdAt',
    'updatedBy',
    'updatedAt',
    'description',
    'tags',
    'searchTimeFrameMinutes',
    'sendToAll',
    'output',
    'correlations',
    'subComponents',
    'schedule',
];
export const UnifiedAlertExportFields = [
    'id',
    'uid',
    'title',
    'createdBy',
    'createdAt',
    'updatedBy',
    'updatedAt',
    'description',
    'tags',
    'searchTimeFrameMinutes',
    'sendToAll',
    'output',
    'source',
    'linkedDashboard',
    'linkedFolder',
    'linkedPanel',
];
//# sourceMappingURL=alert.js.map